const NAME_SEPARATOR = '_-_'
const MUL_VALS = '[Multiple values]'
const MAX_VERSIONS = 10

const REP_SECTIONS = [
    'Section 1 - Site',
    'Section 2 - Systems',
    'Section 3 - Building Envelope',
    'Section 4 - Building Common Areas',
    'Section 5 - Units',
    'Section 6 - Accessibility',
    'Section 7 - Resiliency'
]

const PNA = 'PNA'
const O_AND_M = 'O&M'
const CA11B = 'CA11B'
const ACCESSIBILITY = 'Accessibility'
const LANG_ENTRY_TYPES = [PNA, O_AND_M, CA11B, ACCESSIBILITY]
const IMG_SIZES = ['sm', 'md', 'lg', 'xl']
const IMG_LOCATIONS = ['dropbox', 'dbgallery']

const thumbnailSizeMap = {
  [IMG_SIZES[0]]: 'w128h128',
  [IMG_SIZES[1]]: 'w480h320',
  [IMG_SIZES[2]]: 'w960h640',
  [IMG_SIZES[3]]: 'w1024h768',
}
export {NAME_SEPARATOR, MUL_VALS, MAX_VERSIONS, REP_SECTIONS, LANG_ENTRY_TYPES, ACCESSIBILITY, IMG_SIZES, thumbnailSizeMap, IMG_LOCATIONS}
